var angular = require('angular');

var modalTemplate = require('html/templates/modal')();
var confirmTemplate = require('html/templates/confirm')();

modal.$inject = ['$compile', '$document'];

function modal($compile, $document) {

  // The options object may contain:
  // scope [required]
  // klass
  // title
  // body
  // moveable [boolean]
  // confirmClose [function]
  // onClose [function]
  // onConfirm [function]
  this.open = function(options) {

    var closeOnEscape = function(event) {
      if (event.keyCode === 27) { // ESC
        event.stopImmediatePropagation();
        close();
      }
    };

    var close = function(event) {
      if (event && event.target !== event.currentTarget) return;

      if (typeof options.confirmClose !== 'function' || options.confirmClose()) {
        var modals = $document[0].getElementsByClassName('modal');

        if (modals.length === 1) {
          angular.element($document[0].body).removeClass('modal-open');
        }

        $document.off('keydown', closeOnEscape);
        if (destroyMove) destroyMove();
        angular.element(modals[0]).remove();

        (options.onClose || angular.noop)();
      }
    };

    var template = (options.onConfirm ? confirmTemplate : modalTemplate)
      .replace('{{ klass }}', options.klass || '')
      .replace('{{ body }}', options.body || '&nbsp;')
      .replace(/{{ title }}/g, options.title || '&nbsp;');

    var destroyMove;

    options.scope._modal = {
      close: close,
      onConfirm: options.onConfirm && function() {
        options.onConfirm();
        close();
      }
    };

    if (options.moveable) {
      destroyMove = makeMoveable(options.scope._modal);
    }

    template = $compile(template)(options.scope);

    angular.element($document[0].body)
      .prepend(template)
      .addClass('modal-open');

    $document.on('keydown', closeOnEscape);
  };

}

function makeMoveable(scope) {
  var modalWindow = null;
  var offsetX = 0;
  var offsetY = 0;

  var isInput = function(tag) {
    return tag === 'BUTTON' || tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA';
  };

  var mouseMove = function(event) {
    modalWindow.style.position = 'absolute';
    modalWindow.style.top = (event.clientY - offsetY) + 'px';
    modalWindow.style.left = (event.clientX - offsetX) + 'px';
  };

  scope.moveable = true;

  scope.mouseDown = function(event) {
    // The modal should not move while interacting with an input element
    if (isInput(event.target.tagName)) return;

    modalWindow = event.currentTarget;
    offsetY = event.clientY - +modalWindow.offsetTop;
    offsetX = event.clientX - +modalWindow.offsetLeft;

    angular.element(document.body).addClass('modal-moving');
    window.addEventListener('mousemove', mouseMove, true);
  };

  scope.mouseUp = function() {
    angular.element(document.body).removeClass('modal-moving');
    window.removeEventListener('mousemove', mouseMove, true);
  };

  return scope.mouseUp;
}

module.exports = modal;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/modal.js
 ** module id = 202
 ** module chunks = 1
 **/